export default {
  setCampaigns(state, data) {
    state.lists = data;
  },
};
